import { Outlet } from 'react-router';
import { useBreadcrumb } from '~/components/layout/Breadcrumb';

export default function OtherWikiBreadcrumbRoute() {
  useBreadcrumb('routes/wiki/other', 'Other Articles');
  return <Outlet />;
}
